import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import TableCell from "@material-ui/core/TableCell";
import placeholder from "lib/images/featured-image-tmp.png";
import { PIPELINE, DEAD } from "constants/status";
import DealTableOptionsMenu from "components/Global/OptionsMenu/DealTable/DealTableOptionsMenu";
import numberFormatter from "utils/numberFormatter";
import moment from "moment";
import { map } from "constants/screenElements/deadDealTable";
import DeadDealTableMetricFormatter from "components/Global/Metric/DeadDealTableMetricFormatter";

const getMetricValue = (deal, metricId, dotpath) => {
  const val = _.get(deal, dotpath, null);

  return DeadDealTableMetricFormatter[metricId](val);
};

// TODO: the dead deal table should really use the dead deal table columns
const deadDealEditRedirect = id => `/pipeline/active/deals/${id}`;
const DeadDealTableColumns = () => [
  {
    id: "menu",
    isBaseColumn: true,
    dataField: null,
    layoutOrder: 99,
    numeric: false,
    Cell: ({ deal }) => {
      if (!deal) {
        return null;
      }

      return (
        <TableCell className="loansList_Menu" key="menu">
          <DealTableOptionsMenu id={deal.id} dealEditRedirect={deadDealEditRedirect} />
        </TableCell>
      );
    }
  },
  {
    id: "image",
    isBaseColumn: true,
    dataField: null,
    layoutOrder: -2,
    numeric: false,
    label: " ",
    Cell: ({ deal: { id, imageSmall }, linkPath }) => {
      let path = `/pipeline/active/deals/${id}`;
      if (linkPath) {
        path = linkPath(id);
      }

      return (
        <TableCell className="loansList_TableImage">
          <Link to={path}>
            <img src={imageSmall || placeholder} alt="thumbnailImg" />
          </Link>
        </TableCell>
      );
    }
  },
  {
    id: "name",
    isBaseColumn: true,
    dataField: "name",
    layoutOrder: -1,
    numeric: false,
    label: "Name",
    Cell: ({ deal: { name, id, statusId }, linkPath }) => {
      let path = `/pipeline/active/deals/${id}`;
      if (linkPath) {
        path = linkPath(id);
      }

      return (
        <TableCell className="loansList_Link">
          <Link
            to={`/pipeline/active/deals/${id}`}
          >
            {name}
          </Link>
        </TableCell>
      );
    }
  },
  {
    id: map.TARGETED_CLOSE,
    isBaseColumn: false,
    dataField: "targetedClosing",
    numeric: false,
    label: "Targeted Close",
    Cell: ({ deal: { targetedClosing } }) => (
      <TableCell>{targetedClosing ? moment(targetedClosing).format("L") : "\u2014"}</TableCell>
    )
  },
  {
    id: map.STAGE,
    isBaseColumn: false,
    dataField: "deal.stage.value",
    numeric: false,
    label: "Stage",
    Cell: ({
      deal: {
        stage
      }
    }) => <TableCell>{stage ? stage.value : "\u2014"}</TableCell>
  },
  {
    id: map.STATUS,
    isBaseColumn: false,
    dataField: "deal.dealStatus.value",
    numeric: false,
    label: "Status",
    Cell: ({
      deal: {
        dealStatus
      }
    }) => <TableCell>{dealStatus ? dealStatus.value : "\u2014"}</TableCell>
  },
  {
    id: map.FUND,
    isBaseColumn: false,
    dataField: "deal.fund.name",
    numeric: false,
    label: "Group",
    Cell: ({
      deal: {
        fund
      }
    }) => <TableCell>{fund ? fund.name : "\u2014"}</TableCell>
  },
  {
    id: map.DESIRED_LOAN_AMOUNT,
    isBaseColumn: false,
    dataField: "desiredLoanAmount",
    numeric: false,
    label: "Desired Loan Amount",
    Cell: ({ deal: { desiredLoanAmount } }) => (
      <TableCell>{numberFormatter.maskCurrency(desiredLoanAmount)}</TableCell>
    )
  },
  {
    id: map.APPRAISED_VALUE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.appraisedValue",
    numeric: false,
    label: "Appraised Value",
    Cell: data => {
      const value = getMetricValue(data.deal, map.APPRAISED_VALUE, "dealMetricsV2.appraisedValue");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.PURCHASE_PRICE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.purchasePrice",
    numeric: false,
    label: "Purchase Price",
    Cell: data => {
      const value = getMetricValue(data.deal, map.PURCHASE_PRICE, "dealMetricsV2.purchasePrice");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.CASH_EQUITY,
    isBaseColumn: false,
    dataField: "dealMetricsV2.cashEquity",
    numeric: false,
    label: "Cash Equity",
    Cell: data => {
      const value = getMetricValue(data.deal, map.CASH_EQUITY, "dealMetricsV2.cashEquity");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.BROKER_COMPANY,
    isBaseColumn: false,
    dataField: "deal.brokerCompany.name",
    numeric: false,
    label: "Broker Company",
    Cell: data => {
      const brokerCompany = _.get(data, "deal.brokerCompany.name", "--");

      return (<TableCell>{brokerCompany}</TableCell>);
    }
  },
  {
    id: map.NOI,
    isBaseColumn: false,
    dataField: "dealMetricsV2.noi",
    numeric: false,
    label: "NOI",
    Cell: data => {
      const value = getMetricValue(data.deal, map.NOI, "dealMetricsV2.noi");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.NOI_ACTUAL,
    isBaseColumn: false,
    dataField: "dealMetricsV2.noiActual",
    numeric: false,
    label: "NOI Actual",
    Cell: data => {
      const value = getMetricValue(data.deal, map.NOI_ACTUAL, "dealMetricsV2.noiActual");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.OCCUPANCY,
    isBaseColumn: false,
    dataField: "dealMetricsV2.occupancy",
    numeric: false,
    label: "Occupancy",
    Cell: data => {
      const value = getMetricValue(data.deal, map.OCCUPANCY, "dealMetricsV2.occupancy");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.ASSET_TYPE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.assetTypeName",
    numeric: false,
    label: "Asset Type",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ASSET_TYPE, "dealMetricsV2.assetTypeName");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.ASSET_CLASS,
    isBaseColumn: false,
    dataField: "dealMetricsV2.assetClassName",
    numeric: false,
    label: "Asset Class",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ASSET_CLASS, "dealMetricsV2.assetClassName");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.SQUARE_FEET,
    isBaseColumn: false,
    dataField: "dealMetricsV2.squareFeet",
    numeric: false,
    label: "Square Feet",
    Cell: data => {
      const value = getMetricValue(data.deal, map.SQUARE_FEET, "dealMetricsV2.squareFeet");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.MF_UNITS,
    isBaseColumn: false,
    dataField: "dealMetricsV2.mfUnits",
    numeric: false,
    label: "MF Units",
    Cell: data => {
      const value = getMetricValue(data.deal, map.MF_UNITS, "dealMetricsV2.mfUnits");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.CITY,
    isBaseColumn: false,
    dataField: "dealMetricsV2.city",
    numeric: false,
    label: "City",
    Cell: data => {
      const value = getMetricValue(data.deal, map.CITY, "dealMetricsV2.city");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.STATE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.stateName",
    numeric: false,
    label: "State",
    Cell: data => {
      const value = getMetricValue(data.deal, map.STATE, "dealMetricsV2.stateName");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.TEAM_MEMBER,
    isBaseColumn: false,
    dataField: "teamMember",
    numeric: false,
    label: "Team Member",
    Cell: ({ deal: { teamMember } }) => <TableCell>{teamMember ? `${teamMember.firstName} ${teamMember.lastName}` : "\u2014"}</TableCell>
  },
  {
    id: map.LOAN_SPREAD,
    isBaseColumn: false,
    dataField: "dealMetricsV2.loanSpread",
    numeric: false,
    label: "Loan Spread",
    Cell: data => {
      const value = getMetricValue(data.deal, map.LOAN_SPREAD, "dealMetricsV2.loanSpread");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.ALL_IN_RATE,
    isBaseColumn: false,
    dataField: "dealMetricsV2.allInRate",
    numeric: false,
    label: "All-In Rate",
    Cell: data => {
      const value = getMetricValue(data.deal, map.ALL_IN_RATE, "dealMetricsV2.allInRate");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.LENDER,
    isBaseColumn: false,
    dataField: "dealMetricsV2.lenderName",
    numeric: false,
    label: "Lender",
    Cell: data => {
      const value = getMetricValue(data.deal, map.LENDER, "dealMetricsV2.lenderName");

      return <TableCell>{value}</TableCell>;
    }
  },
  {
    id: map.DEBT_MF_UNIT,
    isBaseColumn: false,
    dataField: "dealMetricsV2.debtMfUnit",
    numeric: false,
    label: "Debt/MF Unit",
    Cell: data => {
      const value = getMetricValue(data.deal, map.DEBT_MF_UNIT, "dealMetricsV2.debtMfUnit");

      return <TableCell>{value}</TableCell>;
    }
  }
];

export default DeadDealTableColumns;
